import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './Css/Homepage.css';
import NavBar from './NavBar';
import Footer from './Footer';
import Header from './Header';
import SideBar from './SideBar'; 
import Moi from './images/Moi.JPG';

const Accueil = () => {

    return (
        <div id="home-page" className="accueil-container-home">
            <NavBar />
            <Header />
            <SideBar />
            <section id="profil" className="accueil-section container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10 col-12 accueil-content">
                        <div className="d-flex flex-column align-items-center">
                            <img src={Moi} alt="Moi" className="rounded-circle mb-3" />
                            <p className="text-center">
  🔓 <strong>À la recherche d'une alternance en développement web</strong>
</p>
<p className="text-center">
  Développeur passionné, avec une appétence pour PHP/Symfony et React. Curieux, motivé, et autonome, je cherche une alternance pour consolider mes compétences techniques dans un environnement stimulant.
</p>
<p className="text-center">
  <strong>+1 :</strong> Une sensibilité à la sécurité, grâce à une formation en cybersécurité, qui à enrichit ma vision du développement.
</p>
<p className="text-center">
  <span role="img" aria-label="seedling">🌱</span> Mon objectif : contribuer à des projets concrets, apprendre vite, et évoluer avec l’équipe sur le long terme.
</p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Accueil;
